import React from "react"

const InfoIcon = ({ ...props }) => {
    return (
        <svg
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M8.5 1.33325C4.82 1.33325 1.83333 4.31992 1.83333 7.99992C1.83333 11.6799 4.82 14.6666 8.5 14.6666C12.18 14.6666 15.1667 11.6799 15.1667 7.99992C15.1667 4.31992 12.18 1.33325 8.5 1.33325ZM8.5 11.3333C8.13333 11.3333 7.83333 11.0333 7.83333 10.6666V7.99992C7.83333 7.63325 8.13333 7.33325 8.5 7.33325C8.86666 7.33325 9.16666 7.63325 9.16666 7.99992V10.6666C9.16666 11.0333 8.86666 11.3333 8.5 11.3333ZM9.16666 5.99992H7.83333V4.66659H9.16666V5.99992Z"
                fill="#8C8594"
            />
        </svg>
    )
}
export default InfoIcon
